<div class="wrapper" onclick="">
  <div class="closed-pulsar" [ngClass]="{ available: service.enabledPlay() }" (click)="toggle()">
    <img src="assets/lucky-cells/lucky-cells.png" alt="pulsar" />
  </div>
  <div class="expand" [ngClass]="{ opened: opened() }" (click)="opened() && openGame()">
    <div class="txts">
      <p class="up">
        {{ 'LUCKY_CELLS.PULSAR.TITLE' | translate }}
      </p>
      <p class="down">
        {{
          service.enabledPlay()
            ? ('LUCKY_CELLS.PULSAR.AVAILABLE' | translate)
            : (service.remainingTimeToPlay() | millisecondsRemaining)
        }}
      </p>
    </div>
    <icon name="ph:arrow-right" />
  </div>
</div>
